var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVirtualNetwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3A99C6;}\r\n\t.st1{fill:#7FBA03;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.5,70.9c0,1-0.4,1.8-1.3,2.3c-1,0.5-2,0.4-2.8-0.4c-1.1-1-2.2-2.1-3.3-3.2c-6-5.8-12.1-11.5-18-17.3 c-1.8-1.7-3.4-3.7-5.1-5.6c-1.4-1.6-1.4-2.8,0.2-4.3c3.9-3.9,7.9-7.8,11.9-11.6c4.6-4.4,9.2-8.9,13.8-13.3c0.8-0.7,1.6-1.3,2.7-0.8 c1,0.5,1.6,1.2,1.7,2.4c0.1,1-0.6,1.6-1.2,2.2c-6.9,6.8-13.7,13.7-20.6,20.5c-2.5,2.5-2.6,3.2-0.1,5.7c6.9,7,13.9,14,20.8,21.1 C45.8,69.2,46.6,69.8,46.5,70.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.9,73.5c-1.9,0-3.1-2-2.1-3.7c0.3-0.5,0.8-1,1.2-1.4c7.1-7.1,14.2-14.2,21.3-21.2c2.1-2.1,2.1-3-0.1-5.1 c-7.1-7-14.3-14-21.4-20.9c-1.3-1.3-1.5-2.6-0.4-3.7c1.1-1.3,2.4-1.2,3.8,0.2c5.8,5.6,11.6,11.2,17.4,16.8c2.7,2.6,5.3,5.2,7.9,7.8 c1.9,1.9,1.9,3.1,0.1,4.9c-8.5,8.4-17,16.8-25.6,25.2C87.4,72.9,86.8,73.5,85.9,73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.4,44.8c0,3.5-3,6.4-6.5,6.4c-3.7,0-7-3.3-7-6.8c0.1-3.5,3.2-6.3,7-6.3C48.5,38.1,51.4,41,51.4,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.5,44.8c0,3.5-3,6.5-6.6,6.4c-3.6-0.1-6.9-3.3-6.9-6.7c0-3.4,3.3-6.4,6.9-6.4 C68.6,38.1,71.5,41.1,71.5,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.4,51.2c-3.7,0-6.7-2.9-6.7-6.5c0-3.5,3-6.5,6.5-6.5c3.6-0.1,6.6,2.9,6.6,6.6C91.9,48.2,89,51.1,85.4,51.2z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualNetwork);
export default __webpack_public_path__ + "static/media/VirtualNetwork.c2ad595e27561945af432e437b3a90da.svg";
export { ForwardRef as ReactComponent };